/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkillSuggestionsRequest
 */
export interface SkillSuggestionsRequest {
    /**
     * 
     * @type {string}
     * @memberof SkillSuggestionsRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SkillSuggestionsRequest
     */
    language?: string;
}

/**
 * Check if a given object implements the SkillSuggestionsRequest interface.
 */
export function instanceOfSkillSuggestionsRequest(value: object): value is SkillSuggestionsRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function SkillSuggestionsRequestFromJSON(json: any): SkillSuggestionsRequest {
    return SkillSuggestionsRequestFromJSONTyped(json, false);
}

export function SkillSuggestionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillSuggestionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function SkillSuggestionsRequestToJSON(value?: SkillSuggestionsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'language': value['language'],
    };
}

